import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyleQuestionCategory = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
  z-index: 1;
  .MuiFormControlLabel-root {
    margin: 0;
  }
  .MuiTextField-root {
    margin-right: 1em;
  }
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.button.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.text.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiTableCell-root {
    padding: 12px 12px;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }

  .MuiTableCell-alignLeft {
    text-align: center;
  }
`;
export const ContentLoaderQuestionCategory = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
`;

export const TableConvention = styled.div`
  display: flex;
  height: auto;
  align-items: center;
  p {
    margin: 0 1em 0 0.4em;
  }
`;

export const useStylesQuestionCategories = makeStyles(() => ({
  active: {
    "& svg": {
      color: theme.button.primary,
    },
    "&:disabled svg": {
      color: theme.neutral.gray[1200],
    },
  },
  delete: {
    color: theme.status.error,
  },
  buttonActive: {
    background: theme.button.primary,
    color: "white",
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
  closeModalResumeAnswer: {},
}));
